import React, { useEffect, useState } from 'react';
import { useRequestPaging } from '@app/hooks/useRequestPaging';
import { getSearchList } from '@common/api/api';
import AdvisorsList, { advisorsListThemes } from '../../advisors_list';
import classes from './classes.module.scss';
import AppLink from '../../routes/app_link';

function SomeOtherAdvisors({
  t,
  theme,
  title,
  subTitle,
  clickSource
}) {
  const startChatClickSource = (window.location.state && window.location.state.startChatClickSource) ? window.location.state.startChatClickSource : 'direct';
  const { loading, loadData } = useRequestPaging(getSearchList);
  const [advisors, setAdvisors] = useState([]);

  const fetchAdvisors = async () => {
    const response = await loadData({ page: 1 }, true);
    setAdvisors(response.advisors.slice(0, 4));
  };

  useEffect(() => {
    fetchAdvisors();
  }, []);

  const generateAnalytics = () => {
    const analyticsData = {
      clickSource,
      startChatClickSource
    };
    return analyticsData;
  };

  return (
    <div className={ classes[theme] }>
      <div className={ classes.titleContainer }>
        <div className={ classes.title }>
          { title }
        </div>
        <div className={ classes.subTitle }>
          { subTitle }
        </div>
      </div>
      <AdvisorsList
        advisors={ advisors }
        theme={ advisorsListThemes.someOtherAdvisor }
        loading={ loading }
        analytics={ generateAnalytics() }
      />
      <div className={ classes.homeButtonContainer }>
        <AppLink
          to="/"
          className={ classes.homeButton }
          replace
        >
          {  t('terminatedAdvisor.back_to_homepage')}
        </AppLink>
      </div>
    </div>
  );
}

export default SomeOtherAdvisors;
